import React from "react";
import { Typography, CardHeader } from "@mui/material";
import ExportOption from "./ExportOption";

const DataGridTitle = (props) => {
  const {
    exportProps,
    endpointFn,
    queryName,
    exportCSV = false,
    tableTitle,
  } = props;
  console.log(
    "DataGridTitle",
    exportProps,
    endpointFn,
    queryName,
    exportCSV,
    tableTitle
  );
  return (
    <>
      {!!tableTitle || exportCSV ? (
        <CardHeader
          sx={{ paddingBottom: "10px" }}
          title={
            !!tableTitle ? (
              <Typography variant="h6">{tableTitle}</Typography>
            ) : null
          }
        >
          {exportCSV ? (
            <ExportOption
              data={exportProps}
              endpointFn={endpointFn}
              queryName={queryName}
            />
          ) : (
            <div></div>
          )}
        </CardHeader>
      ) : null}
    </>
  );
};

export default DataGridTitle;
